import { useTranslation } from 'react-i18next'

const ParentsDivorcingEnd = (props) => {
  const { t } = useTranslation()
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1920 1080"
      role="image"
      aria-labelledby="parents-dicorcing-end-title"
      {...props}
    >
      <title id="parents-dicorcing-end-title">{t('antagonists:parentsdivorcing:components:end')}</title>
      <defs>
        <clipPath id="mum-end-b">
          <path
            d="M1614.14 190.64c-55.24 0-90.3 42.63-91.61 92.13-1.26 47 1.22 65.58 6.12 83.64 7.9 29.18-8.07 55.92-6.46 55.92s44.69-16.43 48.11-24.54c4.06-9.63-1.75-41.5-1.75-41.5l82.09 6.17s-11.57 20.56-.22 37.61c11.35 17.04 38.69 18.86 38.69 18.86s-12.39-30.42-6.71-49.69c5.68-19.25 17.66-42.72 17.66-83.45s-35.62-95.18-85.9-95.18l-.02.02Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <clipPath id="mum-end-c">
          <path
            d="M1595.1 404.9c7.63 5.3 26.98 3.4 32.35 0 12.66-8.05 32.3-28.99 37.32-37.01 6.68-10.69 14.83-62.35-2.21-76.28-28.34-23.16-18.4-52.95-37.69-52.37-11.03.32-21.16 26.92-37.42 41.02-12.17 10.54-33.85 17.74-36.57 27.56-4.04 14.61-3.14 48.62 8.29 64.28 13.53 18.51 23.28 24.03 35.92 32.81v-.02Z"
            style={{
              fill: 'none',
            }}
          />
        </clipPath>
        <style>
          {
            '.d{fill:none}.e{fill:#ee7f00}.f{fill:#feca1b}.g{fill:#00a183}.h{fill:#d4a55e}.i{fill:#a93985}.j{fill:#4a4630}.k{fill:#497125}.l{clip-path:url(#mum-end-c)}.m{clip-path:url(#mum-end-b)}'
          }
        </style>
      </defs>
      <path
        d="M1614.14 190.64c-55.24 0-90.3 42.63-91.61 92.13-1.26 47 1.22 65.58 6.12 83.64 7.9 29.18-8.07 55.92-6.46 55.92s44.69-16.43 48.11-24.54c4.06-9.63-1.75-41.5-1.75-41.5l82.09 6.17s-11.57 20.56-.22 37.61c11.35 17.04 38.69 18.86 38.69 18.86s-12.39-30.42-6.71-49.69c5.68-19.25 17.66-42.72 17.66-83.45s-35.62-95.18-85.9-95.18l-.02.02Z"
        style={{
          fill: '#feca1b',
        }}
      />
      <g
        style={{
          clipPath: 'url(#mum-end-b)',
        }}
      >
        <path
          d="M1621.15 184.51s4.01 28.04 4.01 39.17-1.34 20.26-1.34 20.26l3.79.44s2.45-4.45 1.78-21.58c-.66-17.13-3.33-37.16-3.33-37.16l-4.89-1.1-.02-.02Z"
          style={{
            fill: '#d4a55e',
          }}
        />
      </g>
      <path
        d="M1491.77 731.22c-22.65 6.24-25.83 119.15-27.73 195.49-1.94 78.25 4.81 249.64 6.75 291.39 3.02 64.93.65 264.75.65 264.75s18.15 23.77 46.51 25.39c33.54 1.9 57.74-19.49 57.74-19.49s3.93-161.7-.46-262.33c-2.87-66.2 31.83-267.91 39.64-267.91 9.11 0 1.6 257.44 3.11 277.07 2.09 27.1 6.32 252 6.32 252s20.78 5.62 45.46 4.89c34.68-1.02 49.6-16.77 49.6-16.77s-4.69-242.27-2.53-291.9c1.12-25.69 43.69-177.86 40.92-229.79-3.67-68.65-9.53-148.14-11.03-161.06-9.5-81.7-7.7-162.32-7.7-162.32l-232.04 5.61-15.21 95.01v-.02Z"
        style={{
          fill: '#00a183',
        }}
      />
      <path
        d="m1529.78 456.48 82.98 47.02 96.25-45.54 4.37-16.38s-25.01-2.43-46.1-13.14c-20.43-10.37-19.95-83.23-19.95-83.23l-78.27 6.19s5.3 75.7-26.46 88.06c-32.34 12.57-12.52-2.06-12.52-2.06l-.31 19.08h.02Z"
        style={{
          fill: '#d4a55e',
        }}
      />
      <path
        d="M1610.45 394.42c-12.05 1.51-43.25-6.32-45.95-4.33-8 5.86-4.37 25.91-15.06 30.47s-38.39 14.72-59.81 25.22c-18.13 8.87-9.35 46.63-11.28 64.88s-2.92 99.1 4.84 139.24c7.77 40.15-30.82 123.57-26.61 150.95 4.57 29.67 8.33 44.3 8.48 57.27.27 23.06-5.1 53.27-5.1 53.27s85.95 26.12 173.22 23.6c87.29-2.51 125.37 5.22 125.37 5.22s3.57-54.43 5.71-84.57c1.24-17.59 20.26-29.11 8.85-74.68-5.08-20.34-21.48-95.57-23.82-139.43-2.63-49.36-16.69-85.54-13.59-101.97 5.83-31.03 33.14-62.91 18.78-78.54-20.43-22.23-77.79-36.02-86.05-42.86-8.26-6.85-9.92-26.9-13.32-29.64s-30.09 4.08-44.66 5.9v.02Z"
        style={{
          fill: '#497125',
        }}
      />
      <path
        d="M1595.1 404.9c7.63 5.3 26.98 3.4 32.35 0 12.66-8.05 32.3-28.99 37.32-37.01 6.68-10.69 14.83-62.35-2.21-76.28-28.34-23.16-18.4-52.95-37.69-52.37-11.03.32-21.16 26.92-37.42 41.02-12.17 10.54-33.85 17.74-36.57 27.56-4.04 14.61-3.14 48.62 8.29 64.28 13.53 18.51 23.28 24.03 35.92 32.81v-.02Z"
        style={{
          fill: '#d4a55e',
        }}
      />
      <g
        style={{
          clipPath: 'url(#mum-end-c)',
        }}
      >
        <path
          d="M1594.51 281.01s-15.72-2.01-21.84 2.5c-8.55 6.29-15.75 12.32-15.75 12.32l3.4 4.59s11.79-8.02 15.12-10.04c5.44-3.3 20.39-2.41 20.39-2.41s-.95-7.53-1.34-6.95h.02ZM1624.33 278.87s11.89-1.12 19.88-.24c8 .88 17.13 8 17.13 8l-3.06 4.93s-11.1-6.66-15.36-6.08c-4.88.66-19.29.42-19.29.42s.22-7.56.68-7.02l.02-.02Z"
          style={{
            fill: '#4a4630',
          }}
        />
      </g>
      <path
        d="M1629.31 367.01c-2.58 4.91-14.75 16.38-21.95 16.99-8.14.7-12.78-6.73-14.58-7.95-1.8-1.22 1-11.45 5.88-14.66 4.76-3.14 11.23-2.53 13.75-3.52s6.85-2.55 11.16-2.36c4.1.17 7.44 8.26 5.76 11.5h-.02Z"
        style={{
          fill: '#ee7f00',
        }}
      />
      <path
        d="m1578.21 312.45-8.38 1.34-.54-2.96 10.23-2.16s-1.02 3.7-1.31 3.79v-.02Z"
        style={{
          fill: '#4a4630',
        }}
      />
      <path
        style={{
          fill: '#4a4630',
        }}
        d="m1579.42 310.93-8.68-6.01 1.63-2.59 8.07 5.19-1.02 3.41z"
      />
      <path
        d="M1578.08 305.8c-2.45 2.18-2.72 5.37-.49 7.68 2.23 2.33 4.66 1.92 6.98.1 2.75-2.14 2.96-4.61.92-7.22-1.44-1.85-4.88-2.8-7.41-.56ZM1633.95 311.71l8.34 1.51.61-2.96-10.18-2.38s.95 3.72 1.22 3.81v.02Z"
        style={{
          fill: '#4a4630',
        }}
      />
      <path
        style={{
          fill: '#4a4630',
        }}
        d="m1633.34 309.9 8.48-5.61-1.51-2.52-7.89 4.83.92 3.3z"
      />
      <path
        d="M1633.36 305.65c2.4 2.23 2.6 5.42.32 7.7-2.28 2.28-4.94 1.43-7.22-.42-2.7-2.21-2.62-4.3-.51-6.87 1.48-1.82 4.94-2.7 7.43-.39l-.02-.02Z"
        style={{
          fill: '#4a4630',
        }}
      />
      <path
        d="M1666.51 294.88c-.8-1.12-33.15 0-41.51.25-5.73.19-10.5 4.16-18.52 4.45s-13.03-3.48-18.76-3.3c-8.36.25-40.73 1.16-41.46 2.33s-.46 5.74.53 6.08c.97.36 2.35 1.27 2.58 2.6.24 1.34 3.11 18.2 5.9 21.34 4.04 4.57 9.23 3.99 16.72 4.33 7.49.34 18.81-.41 21.5-6.49 1.97-4.49 2.75-6.93 5.78-14.6 1.48-3.74 3.55-5.34 7.15-5.44 3.59-.12 6.32 1.33 8.04 4.98 3.48 7.46 4.42 9.86 6.66 14.21 3.06 5.91 14.39 5.95 21.85 5.15 7.46-.82 12.66-.56 16.42-5.37 2.58-3.31 4.42-20.32 4.57-21.67s1.46-2.35 2.41-2.77c.95-.41.95-5 .14-6.12l.02.02Zm-72.9 16.26c-.95 5.1-1.55 12.8-7.65 16.42-4.6 2.75-19.44 1.5-22.8.51-3.64-1.05-5.93-3.94-6.61-7.34s-1.7-9.53-1.95-11.42c-.25-1.9.05-5.73 3.42-6.37 4.93-.95 25.57-2.18 31.33-.78 3.35.82 5.2 3.96 4.27 8.99Zm65.22-5.06c-.14 1.9-.78 8.09-1.26 11.52-.46 3.43-2.58 6.44-6.13 7.73-3.28 1.19-18.01 3.35-22.79.9-6.3-3.25-7.39-10.88-8.63-15.92-1.24-4.96.42-8.22 3.7-9.24 5.66-1.75 26.34-1.82 31.32-1.16 3.4.44 3.93 4.25 3.81 6.15l-.02.02Z"
        style={{
          fill: '#a93985',
        }}
      />
      <path
        d="M1410.83 739.03c17.21 15.04 66.25-9.36 77.25-27.53 11.01-18.15 37.66-153.19 37.66-153.19l-15.72-120.11s-61.26 13.24-71.39 59.27c-10.11 46.05-56.91 216.11-27.82 241.55h.02ZM1785.46 743.67c-18.18 13.83-25.66 8.02-35.48-10.79-11.45-21.99-57.59-139.95-55.91-136.88l48.24-144.61s36.18 15.77 43.13 62.4 30.76 206.5 0 229.88h.02Z"
        style={{
          fill: '#497125',
        }}
      />
      <path
        d="M1523.12 675.96s53.75-13.46 58.52-16.64c3.3-2.19 26.37-27.94 31.18-31.18 3.3-2.23 40.43-22.21 45.74-23.59 4.94-1.27 28.46-7.8 28.46-7.8s3.09 7.36-4.28 11.23c-7.39 3.87-20.58 7.12-22.97 8.02s-20.46 10.69-21.33 10.96c-1.24.39-.51 2.12.49 1.84 1.73-.51 20.88-9.31 23.06-9.94 2.18-.63 34.07-12.34 34.07-12.34s3.04 6.63-1.67 10.71c-5.96 5.17-25.06 10.98-26.95 11.5s-22.41 10.23-24.21 10.98c-1.34.56-.95 1.75.49 1.67 1.36-.08 16.94-4.79 24.88-7.49 5.56-1.89 28.9-8.56 28.9-8.56s3.18 8.79-4.6 11.61c-6.27 2.28-19.59 6.3-23.09 7.24s-19.78 6.93-20.75 7.36c-1.51.65-1.14 1.55.37 1.39 1.07-.12 15.02-3.13 17.33-3.82 2.31-.68 23.91-3.87 23.91-3.87s2.91 5.88-2.07 8.9c-2.77 1.68-16.14 3.69-21.44 5.22-3.7 1.07-31.98 9.13-35.07 10.94-3.98 2.33-25.9 12.51-31.18 14.68-6.54 2.68-65.37 33.87-65.37 33.87l-12.4-42.92-.02.05Z"
        style={{
          fill: '#d4a55e',
        }}
      />
      <path
        d="M1581.32 646.9c-16.92-11.61-55.79-5.39-98.42 10.18-30.5 11.13-62.4-4.83-68.21 3.76-5.83 8.6-11.03 41.26-11.03 41.26l-.48 14.87s1.97 37.86 15.79 40.04c18.23 2.87 64.91-11.69 95.5-15.58 19.92-2.53 106.02-41.26 106.02-41.26s-20.51-40.49-39.13-53.29l-.03.03Z"
        style={{
          fill: '#497125',
        }}
      />
      <path
        d="M1805.2 814.06s14.33 72.97 16.14 80.09c3.7 14.51 6.97 48.8 4.54 54.7-2.45 5.88-15.96 31.91-17.74 34.33-5.05 6.85-33.25 15.07-33.25 15.07s-1.78-7.92 4.08-14.34c3.67-4.01 15.29-10.38 14.56-25.74-.63-13.27.93-23.94-8.05-23.23-7 .54-3.7 20.44-6.46 27.14-2.96 7.24-10.76 6.9-10.76 6.9s-2.35-34.65-1.63-44.47c.68-9.41 7.02-35.5 6.83-42.79-.09-3.5-11.74-71.15-11.74-71.15l43.5 3.48-.02.02Z"
        style={{
          fill: '#d4a55e',
        }}
      />
      <path
        d="M1770.79 476.29s43.11 198.8 50.54 231.51c8.16 35.87 24.91 121.14 19.56 130.44-5.34 9.3-17.93 55.43-17.93 55.43l-53.8 4.89s-9.02-36.09-9.79-50.54-17.47-193.16-27.72-223.35c-6.66-19.68 0-163.03 0-163.03l39.13 14.68v-.03Z"
        style={{
          fill: '#497125',
        }}
      />
    </svg>
  )
}

export default ParentsDivorcingEnd
